import color from 'core/libs/color';
import deepmerge from 'core/libs/deepmerge';

import withBindProps from 'core/hocs/withBindProps';

import ArrowRegularSharp from '../components/Icon/ArrowRegularSharp';
import PremiumStory from '../components/Icon/PremiumStory';
import CloseIcon from '../components/Icon/Close';
import Burger from '../components/Icon/Burger';
import Search from '../components/Icon/Search';
import ArrowLeft from '../components/Icon/ArrowLeft';
import ArrowRight from '../components/Icon/ArrowRight';
import ArrowDropdown from '../components/Icon/ArrowDropdown';
import ArrowShare from '../components/Icon/ArrowShare';
import Comments from '../components/Icon/Comments';
import Maximize from '../components/Icon/Maximize';
import Download from '../components/Icon/Download';
import Video from '../components/Icon/Video';
import Photo from '../components/Icon/Photo';
import Send from '../components/Icon/Send';
import DefaultAvatar from '../components/Icon/DefaultAvatar';
import Winner from '../components/Icon/Winner.svg';
import Vs from '../components/Icon/Vs.svg';
import EmptyWrapper from 'core/components/EmptyWrapper';
import Card2 from 'core/components/Amp/cards/Card2';
import Feed from 'core/components/Feed/Amp';

import Indent from 'core/components/Wrappers/Indent';

import Arrows from '../components/Paginatron/Arrows';

import { DISCUSS_BUTTON_TEXT } from 'core/site/constants';

// TODO: синхронизировать иконки с RamblerShare и/или получить публичный
// апи к созданию кнопок в RamblerShare чтоб была возможность реализовать
// кастомную верстку кнопок
import {
  Youtube,
  Vkontakte,
  Twitter,
  Odnoklassniki,
  Instagram,
  Facebook,
  Telegram,
  YandexDzen,
  LivejournalWhite,
  PodcastLivejournal,
  ExternalSite,
  TikTok,
} from 'core/components/Icon/socials';

import { MOBILE, DESKTOP } from 'core/components/breakpoint/values';
import { DESKTOP_SMALL, viewportBreakpoints } from 'core/components/breakpoint/viewport-values';


export default function stylesAtomsFactory(params = {}) {
  /**
 * Набор дефолтных шрифтов.
 *
 * Обычно он должен полностью переопределяться в рамках конкретного сайта.
 */
  const fonts = {
    display: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
    text: 'TimesNewRoman, "Times New Roman", Times, Georgia, serif',
    nuance: 'Georgia, Times, "Times New Roman", serif',
    ...params.fonts,
  };

  /**
   * Набор дефолтных цветов.
   *
   * Обычно он должен полностью переопределяться в рамках конкретного сайта.
   */
  const colors = {
    layout: '#fff',
    content: '#fff',
    card: '#fff',
    active1: '#a68b5c',
    active2: '#dfc991',
    accent: '#efe5d4',
    error: '#ff3e56',
    success: '#2AB56E',
    primary: '#000',
    input: '#fff',
    hint: 'rgba(0, 0, 0, .5)',
    placeholder: 'rgba(0, 0, 0, .3)',
    fullscreenBg: '#1c1c1c',
    theme: '#a68b5c',
    ...params.colors,
  };

  const layout = deepmerge({
    maxWidth: '1280px',
    viewportWidth: viewportBreakpoints[DESKTOP_SMALL],
    minWidth: viewportBreakpoints[DESKTOP_SMALL],
    sideColumnIndent: '20px',
    rightColumnWidth: '300px',
    contentColumnMaxWidth: '860px',
    boxShadow: '0 0 20px 10px rgba(0, 0, 0, .1)',
    indents: {
      top: 30,
      right: 30,
      bottom: 30,
      left: 30,
    },
  }, params.layout || {});

  const texts = deepmerge({
    title1: {
      font: `bold 72px/78px ${fonts.display}`,
      color: colors.primary,
    },

    title2: {
      font: `bold 34px/42px ${fonts.display}`,
      color: colors.primary,
    },

    title3: {
      font: `bold 24px/29px ${fonts.display}`,
      color: colors.primary,
    },

    title4: {
      font: `bold 18px/23px ${fonts.display}`,
      color: colors.primary,
    },

    title5: {
      font: `bold 16px/18px ${fonts.text}`,
      color: colors.primary,
    },

    title6: {
      font: `bold 14px/16px ${fonts.text}`,
      color: colors.primary,
    },

    headline: {
      font: `bold 48px/52px ${fonts.display}`,
      color: colors.primary,
    },

    body: {
      font: `18px/26px ${fonts.text}`,
      color: colors.primary,
    },

    get tableCell() {
      return this.body;
    },

    bodySmall: {
      font: `14px/16px ${fonts.text}`,
      color: colors.primary,
    },

    lead: {
      font: `bold 28px/34px ${fonts.display}`,
      color: colors.primary,
    },

    incut: {
      font: `italic 28px/34px ${fonts.text}`,
      color: colors.primary,
    },

    get quote() {
      return this.incut;
    },

    caption1: {
      font: `14px/16px ${fonts.display}`,
      color: colors.hint,
    },

    caption2: {
      font: `14px/16px ${fonts.display}`,
      color: colors.primary,
    },

    caption3: {
      font: `14px/18px ${fonts.display}`,
      color: colors.placeholder,
    },

    caption4: {
      font: `bold 14px/18px ${fonts.display}`,
      color: colors.primary,
    },

    caption5: {
      font: `bold 16px/18px ${fonts.display}`,
      color: colors.primary,
    },

    decor1: {
      font: `bold italic 38px/36px ${fonts.nuance}`,
      color: colors.primary,
    },
  }, params.texts || {});

  const icons = {
    logo: () => 'Logo',
    close: CloseIcon,
    burger: Burger,
    search: Search,
    arrowLeft: ArrowLeft,
    arrowRight: ArrowRight,
    ArrowDropdown: ArrowDropdown,
    arrowShare: ArrowShare,
    comments: Comments,
    maximize: Maximize,
    download: Download,
    send: Send,
    DefaultAvatar,
    Video,
    Photo,
    ...params.icons,
  };

  const socials = deepmerge({
    yandex_dzen: {
      icon: YandexDzen,
      color: '#2c3036',
      width: '36',
      height: '36',

      [MOBILE]: {
        width: '32',
        height: '32',
      },
    },
    livejournalwhite: {
      icon: LivejournalWhite,
      color: '#004359',
    },
    podcastlivejournal: {
      icon: PodcastLivejournal,
      color: '#004359',
    },
    instagram: {
      icon: Instagram,
      color: '#de376f',
    },
    youtube: {
      icon: Youtube,
      color: '#ff0000',
    },
    twitter: {
      icon: Twitter,
      color: '#55acee',
    },
    facebook: {
      icon: Facebook,
      color: '#3a5795',
    },
    vkontakte: {
      icon: Vkontakte,
      color: '#597da3',
    },
    odnoklassniki: {
      icon: Odnoklassniki,
      color: '#f2720c',
    },
    telegram: {
      icon: Telegram,
      color: '#179cde',
    },
    tiktok: {
      icon: TikTok,
      color: '#000',
      height: 36,
      width: 36,
    },
    external_site: {
      icon: ExternalSite,
      color: 'transparent',
      height: 36,
      width: 36,
    },
  }, params.socials || {});

  const animations = {
    hover: '200ms ease-in-out',
    ...params.animations,
  };

  const link = {
    article: {
      idle: {
        color: colors.active1,
        decoration: 'underline',
      },

      hover: {
        color: color(colors.primary).mix(color(colors.primary), 0.2).string(),
        decoration: 'underline',
      },

      active: {
        color: color(colors.primary).mix(color(colors.primary), 0.2).string(),
        decoration: 'underline',
      },

      visited: {
        color: color(colors.active1).alpha(0.8).string(),
        decoration: 'underline',
      },
    },

    primary: {
      idle: {
        color: colors.active1,
        decoration: 'none',
      },

      hover: {
        color: colors.primary,
        decoration: 'none',
      },

      active: {
        color: color(colors.active1).mix(color(colors.primary), 0.2).string(),
        decoration: 'none',
      },

      visited: {
        color: color(colors.primary).alpha(0.8).string(),
        decoration: 'none',
      },
    },

    secondary: {
      idle: {
        color: colors.active2,
        decoration: 'none',
      },

      hover: {
        color: color(colors.active2).mix(color(colors.primary), 0.2).string(),
        decoration: 'none',
      },

      active: {
        color: color(colors.active2).mix(color(colors.primary), 0.2).string(),
        decoration: 'none',
      },

      visited: {
        color: color(colors.active2).alpha(0.8).string(),
        decoration: 'none',
      },
    },

    tertiary: {
      idle: {
        color: colors.primary,
        decoration: 'none',
      },

      hover: {
        color: colors.active1,
        decoration: 'none',
      },

      active: {
        color: color(colors.active1).mix(color(colors.primary), 0.2).string(),
        decoration: 'none',
      },

      visited: {
        color: color(colors.primary).alpha(0.8).string(),
        decoration: 'none',
      },
    },

    footer: {
      idle: {
        color: colors.primary,
        decoration: 'none',
      },

      hover: {
        color: colors.active1,
        decoration: 'none',
      },

      active: {
        color: color(colors.active1).mix(color(colors.primary), 0.2).string(),
        decoration: 'none',
      },

      visited: {
        color: colors.primary,
        decoration: 'none',
      },
    },
  };

  const smartTeaser = {
    carRelease: {
      title: {
        font: `700 20px/25px ${fonts.display}`,
        color: colors.primary,
      },
      info: {
        font: `700 14px/17px ${fonts.text}`,
      },
      caption: {
        font: `300 13px/15px ${fonts.text}`,
        color: colors.hint,
      },
      link: {
        textDecoration: 'none',
        borderBottom: `1px ${colors.primary} solid`,
        color: 'inherit',
        hover: {
          textDecoration: 'none',
          borderBottom: '1px transparent solid',
          color: 'inherit',
        },
      },
    },
    gameCompare: {
      lightningColor: colors.layout,
      progressType: 0,
      borderRadius: '8px 8px 0 0',
      imageMaxWidth: 580,
      border: {
        showBorder: false,
        borderValue: `1px solid ${colors.divider}`,
      },
      padding: '13px 70px 40px',
      headline: {
        font: `700 24px/35px ${fonts.display}`,
        color: colors.primary,
        background: colors.layout,
        center: false,
      },
      background: colors.active1,
      readMore: {
        font: `14px/17px ${fonts.text}`,
        color: colors.primary,
        text: 'Читайте на тему:',
      },
    },
  };

  const sizes = {
    extraSmall: {
      font: `9px/12px ${fonts.text}`,
      padding: '6px',
      height: '20px',
      width: '60px',
    },
    small: {
      font: `16px/18px ${fonts.text}`,
      width: '100px',
      height: '32px',
      padding: '6px 14px',
    },

    medium: {
      font: `20px/24px ${fonts.text}`,
      width: '140px',
      height: '46px',
      padding: '10px 20px',
    },

    large: {
      font: `22px/26px ${fonts.text}`,
      width: '180px',
      height: '52px',
      padding: '10px 30px',
    },

    extraLarge: {
      font: `14px/16px ${fonts.text}`,
      width: '280px',
      height: '48px',
      padding: '10px 50px',
    },
  };

  const button = {
    const: {
      sizes,
      radius: '45px',
      textTransform: 'none',
    },

    primary: {
      idle: {
        color: colors.primary,
        background: colors.active1,
        border: 'none',
      },

      hover: {
        color: colors.primary,
        background: (
          color(colors.active1)
            .mix(color(colors.primary), 0.2)
            .string()
        ),
        border: 'none',
      },

      active: {
        color: colors.primary,
        background: (
          color(colors.active1)
            .mix(color(colors.primary), 0.2)
            .string()
        ),
        border: 'none',
      },

      disabled: {
        color: color(colors.primary).alpha(0.4).string(),
        background: color(colors.active1).alpha(0.4).string(),
        border: 'none',
      },
    },

    secondary: {
      idle: {
        color: colors.primary,
        background: 'none',
        border: `1px solid ${colors.active1}`,
      },

      hover: {
        color: colors.primary,
        background: color(colors.active1).alpha(0.2).string(),
        border: `1px solid ${colors.active1}`,
      },

      active: {
        color: colors.primary,
        background: color(colors.active1).alpha(0.2).string(),
        border: `1px solid ${colors.active1}`,
      },

      disabled: {
        color: color(colors.primary).alpha(0.4).string(),
        background: 'none',
        border: `1px solid ${color(colors.active1).alpha(0.4).string()}`,
      },
    },

    ghost: {
      idle: {
        color: colors.primary,
        background: 'none',
        border: 'none',
      },

      hover: {
        color: colors.active1,
        background: 'none',
        border: 'none',
      },

      active: {
        color: colors.active1,
        background: 'none',
        border: 'none',
      },

      disabled: {
        color: color(colors.primary).alpha(0.4).string(),
        background: 'none',
        border: 'none',
      },
    },

    tertiary: {
      idle: {
        color: colors.layout,
        background: colors.active1,
        border: 'none',
      },

      hover: {
        color: colors.layout,
        background: color(colors.active1).alpha(0.2).string(),
        border: 'none',
      },

      active: {
        color: colors.layout,
        background: color(colors.active1).alpha(0.2).string(),
        border: 'none',
      },

      disabled: {
        color: colors.layout,
        background: colors.active1,
        border: 'none',
      },
    },
  };

  const input = {
    const: {
      sizes,
      radius: '4px',
      color: colors.primary,
    },

    basic: {
      idle: {
        background: colors.input,
        border: `1px solid ${colors.hint}`,
        placeholderColor: colors.placeholder,
      },

      hover: {
        background: colors.input,
        border: `1px solid ${colors.placeholder}`,
        placeholderColor: colors.placeholder,
      },

      focused: {
        background: colors.input,
        border: `1px solid ${colors.active1}`,
        placeholderColor: colors.placeholder,
      },

      disabled: {
        background: (
          color(colors.input)
            .mix(color(colors.primary), 0.05)
            .string()
        ),
        border: `1px solid ${colors.hint}`,
        placeholderColor: colors.placeholder,
      },

      error: {
        background: colors.input,
        border: `1px solid ${colors.error}`,
        placeholderColor: colors.placeholder,
      },
    },
  };

  const searchInput = {
    /**
     * Показывать ли полноценную кнопку рядом с инпутом вместо иконки
     * Можно переопределить свойством
     */
    withButton: false,
    placeholder: 'Поиск',

    icons: {
      Search: icons.search,
      Close: CloseIcon,
    },

    iconStyles: {
      withoutText: {
        idle: {
          color: input.basic.idle.placeholderColor,
        },

        hover: {
          color: input.basic.idle.placeholderColor,
        },

        focused: {
          color: input.basic.idle.placeholderColor,
        },

        disabled: {
          color: input.basic.idle.placeholderColor,
        },
      },

      withText: {
        idle: {
          color: color(input.const.color).alpha(0.6).string(),
        },

        hover: {
          color: color(input.const.color).alpha(0.6).string(),
        },

        focused: {
          color: color(input.const.color).alpha(0.6).string(),
        },

        disabled: {
          color: input.basic.idle.placeholderColor,
        },
      },
    },
  };

  const drum = {
    const: {
      bottomSpacing: '20px',
      bulletsMargin: '20px 0 0 0',
    },

    link: {
      font: texts.caption5.font,
    },

    arrow: {
      Left: icons.arrowLeft,
      Right: icons.arrowRight,

      width: '40',
      height: '40',

      fade: {
        outer: colors.content,
        inner: '#fff0',
      },

      idle: {
        color: colors.active2,
      },

      hover: {
        color: color(colors.active2).alpha(0.6).string(),
      },
    },

    headerArrows: {
      const: {
        Left: icons.arrowLeft,
        Right: icons.arrowRight,
        width: 14,
        height: 20,
      },

      basic: {
        idle: {
          color: colors.primary,
        },

        hover: {
          color: color(colors.primary).alpha(0.8).string(),
        },

        inactive: {
          color: color(colors.primary).alpha(0.3).string(),
        },
      },
    },
  };

  const bullet = {
    const: {
      size: '8px',
    },

    basic: {
      idle: {
        background: colors.placeholder,
      },

      hover: {
        background: (
          color(colors.placeholder)
            .mix(color(colors.primary), 0.2)
            .string()
        ),
      },

      active: {
        background: colors.active1,
      },
    },
  };

  const bullets = {
    const: {
      bulletMargin: '0 5px',
    },
  };

  const counter = {
    ...texts.caption4,
  };

  const vikontImage = {
    maxWidthAside: 300,
    maxHeight: 800,
    maxWidth: 860,
    captionMargin: '10px 0 0 0',
  };

  /**
   * Набор стилей сильно не продумывался с мыслью, что они позже будут
   * переделаны с учетом предложенного формата:
   *
   * https://gist.github.com/a-ignatov-parc/292b17f7c2808558b01b8cee6f5157ef
   */
  const gallery = {
    icons: {
      Close: icons.close,
      Download: icons.download,
      background: color(colors.primary).alpha(0.75).string(),
    },

    captions: {
      padding: 0,
    },

    thumb: {
      reloadIconColor: colors.active1,
      borderRadius: 0,
      idle: {
        fade: 'none',
        borderColor: 'transparent',
      },

      hover: {
        fade: color(colors.primary).alpha(0.2).string(),
        borderColor: 'transparent',
      },

      active: {
        fade: color(colors.primary).alpha(0.2).string(),
        borderColor: colors.active1,
      },
    },

    slide: {
      background: 'transparent',
      borderRadius: 0,
    },

    info: {
      padding: '15px 0',
    },

    arrows: {
      Left: icons.arrowLeft,
      Right: icons.arrowRight,

      idle: {
        fill: color(colors.primary).alpha(0.5).string(),
        stroke: 'transparent',
      },
      idleFullscreen: {
        fill: color('#FFF').alpha(0.5).string(),
        stroke: 'transparent',
      },
      hover: {
        fill: colors.primary,
        stroke: 'transparent',
      },
      hoverFullscreen: {
        fill: '#FFF',
        stroke: 'transparent',
      },
    },

    fullscreen: {
      background: colors.fullscreenBg,

      imageInfo: {
        background: color(colors.content).alpha(0.5).string(),
        faderTransparency: color(colors.content).alpha(0).string(),
      },
    },
  };

  const topicPages = {
    text: texts.caption5,
    arrow: {
      idle: {
        color: button.ghost.idle.color,
      },
      hover: {
        color: button.ghost.hover.color,
      },
      size: '21px',
    },
  };

  const paginatron = {
    btnSize: 'medium',
    btnType: 'ghost',
    withoutBorder: false,
    withOuterButtons: true,
    round: true,
    separationText: ' из ',
    PrevPage: withBindProps({ side: 'left' })(Arrows),
    NextPage: withBindProps({ side: 'right' })(Arrows),
    radius: button.const.radius,
    background: 'none',
    justifyContent: 'space-evenly',
    countersMargin: 0,

    text: {
      font: `20px/24px ${fonts.text}`,
      color: colors.primary,
    },

    icon: {
      arrow: {
        size: '21px',
      },

      doubleArrow: {
        size: '21px',
      },
      idle: {
        fill: button.ghost.idle.color,
      },
      hover: {
        fill: button.ghost.hover.color,
      },
      disabled: {
        fill: button.ghost.disabled.color,
      },
    },

    outerButtons: {
      innerBorder: button.secondary.idle.border,
      idle: {
        background: button.secondary.idle.background,
        color: button.secondary.idle.color,
      },
      disabled: {
        background: button.secondary.disabled.background,
        color: button.secondary.disabled.color,
      },
      hover: {
        background: button.secondary.hover.background,
        color: button.secondary.hover.color,
      },
    },
  };

  const spammer = {
    header: {
      font: `bold 30px/38px ${fonts.display}`,
      color: colors.primary,
      mobile: {
        font: `bold 18px/25px ${fonts.display}`,
      },
    },

    errorMessage: {
      color: colors.error,
    },

    Icon: icons.send,
    background: colors.layout,

    [MOBILE]: {
      borderRadius: '0',
      formElements: {
        radius: '26px',
        size: 'medium',
      },
    },

    [DESKTOP]: {
      borderRadius: '20px',
      formElements: {
        radius: '26px',
        size: 'large',
      },
    },
  };

  const shapkaLink = {
    font: `normal 16px/18px ${fonts.text}`,
    textTransform: 'none',
    padding: '6px 9px',
    letterSpacing: 'normal',

    idle: {
      color: colors.primary,
      decoration: 'none',
    },

    hover: {
      color: colors.active1,
      decoration: 'none',
    },

    active: {
      color: color(colors.active1).mix(color(colors.primary), 0.2).string(),
      decoration: 'none',
    },

    current: {
      color: colors.active1,
      decoration: 'none',
    },
  };

  const shapkaDropdown = {
    link: {
      ...shapkaLink,
      padding: '10px 15px',
    },
    more: shapkaLink,
    background: colors.content,
    padding: '0 30px 0 0',
    height: '200px',
    fullwidth: false,
    trigger: 'hover',
    position: 'left',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.15)',
    borderRadius: '5px',
    marginTop: '-5px',
  };

  const shapka = {
    subnav: 'right',
    sticky: true,
    ArrowDropdown: icons.ArrowDropdown,
    link: shapkaLink,
    dropdown: {
      ...shapkaDropdown,
      premiumTopic: {
        ...shapkaDropdown,
        link: {
          ...shapkaLink,
          padding: '8px 20px 8px 0',
        },
        padding: '20px',
        trigger: 'click',
        background: 'none',
        position: 'center',
        marginTop: '0',
      },
    },

    logo: {
      Icon: icons.logo,
      marginTop: 0,
    },

    burger: {
      Icon: icons.burger,
      width: 20,
      height: 20,
    },

    close: {
      Icon: icons.close,
      width: 14,
      height: 14,
    },

    height: 100,
    padding: '0 15px 0 22px',
    shadow: '0 0 30px 0 rgba(0, 0, 0, .4)',
    shadowTransition: 'opacity .2s',
    background: colors.content,
    stickyBackground: colors.content,
    backgroundOpened: colors.content,

    menu: {
      centered: false,
      right: false,
      hideBouesque: false,
      navMargin: '0 0 0 20px',
      itemDivider: 'none',
    },

    labelNoAds: {
      fontWeight: 'normal',
      color: '#fff',
      backgroundColor: colors.active1,
      textTransform: 'none',
    },
  };

  const scooter = {
    header: {
      padding: '20px 0',
      borderTop: 0,
    },
    border: `1px solid ${colors.divider}`,
    background: colors.content,
    padding: '0 40px',
    social: {
      idle: {
        color: colors.active2,
        background: 'transparent',
        border: `1px solid ${colors.active2}`,
      },
      hover: {
        color: color(colors.input).alpha(0.9).toString(),
        background: color(colors.active2).alpha(0.8).toString(),
        border: `1px solid ${color(colors.active2).alpha(0.8).toString()}`,
      },
      margin: '0 0 0 30px',
      size: 52,
      iconSize: 18,
      borderRadius: 27,
    },
    servicesItem: {
      marginTop: '10px',
    },
    menuLink: {
      textTransform: 'none',
      letterSpacing: 'normal',
      ...texts.body,

      idle: {
        color: colors.primary,
        decoration: 'none',
      },

      hover: {
        color: colors.active1,
        decoration: 'none',
      },

      active: {
        color: color(colors.active1).mix(color(colors.primary), 0.2).string(),
        decoration: 'none',
      },

      current: {
        color: colors.active1,
        decoration: 'none',
      },
    },
    menuItem: {
      pinnedSideItems: false,
    },
    logo: {
      Icon: icons.logo,
      width: '300px',
      height: 'auto',
      marginTop: 0,
    },
    commercial: {
      border: '1px solid transparent',
    },
  };

  const commentButton = {
    type: 'primary',
    text: DISCUSS_BUTTON_TEXT,
    textTransform: 'none',
    font: `14px/16px ${fonts.nuance}`,
    icon: {
      width: '24px',
      height: '20px',
      showValueInIcon: false,
      position: 'left',
    },
    size: 'medium',
    topSpacing: 0,
  };

  const topicFooter = {
    links: {
      type: 'footer',
      showComma: true,
      borderBottom: `1px ${colors.primary} solid`,
      font: 'inherit',
      color: 'inherit',
      title: {
        font: 'inherit',
        color: 'inherit',
      },
      hover: {
        borderBottom: '1px transparent solid',
      },
      marginLeft: '5px',
    },
    socialMedia: {
      type: 'fancy',
    },
    block: {
      interitemSpacing: 15,
      spacing: 40,
    },
  };

  const logo = {
    linkHref: '/',
  };

  const comments = {
    const: {
      font: fonts.display,
      CountIcon: icons.comments,
    },
  };

  const topicTags = {
    font: texts.body.font,
    color: colors.primary,
    showHash: true,
  };

  const bouesque = {
    const: {
      size: 'small',
    },
  };

  const vikontOpinion = {
    bodyFontStyle: 'normal',
    opinion: {
      maxWidth: '820px',
      width: 'auto',
      padding: '4px 75px 16px 0',
    },
    job: {
      font: `400 16px/20px ${fonts.text}`,
    },
    name: {
      font: `700 20px/28px ${fonts.display}`,
      marginBottom: '5px',
    },
    authorImage: {
      size: 64,
      marginRight: '28px',
    },
    body: {
      marginBottom: '28px',
      paddingLeft: '42px',
    },
    bodyBefore: {
      width: '10px',
    },
  };

  const vikontSpoiler = {
    const: {
      borderColor: colors.divider,
    },
    icons: {
      arrowRegularSharp: ArrowRegularSharp,
    },
    title: {
      color: colors.primary,
      font: `700 22px/34px ${fonts.display}`,
    },
    block: {
      outerIndent: '28px 0 33px',
      innerIndent: '7px 0 9px',
      interitemSpacing: 20,
      background: 'transparent',
      borderRadius: 0,
    },
    body: {
      font: texts.body.font,
      padding: '0 0 20px',
    },
  };

  const vikontVerdict = {
    title: {
      color: colors.primary,
      font: `500 24px/28px ${fonts.display}`,
    },
    text: {
      color: colors.primary,
      font: `400 18px/27px ${fonts.display}`,
    },
    score: {
      color: colors.accent,
    },
    block: {
      background: 'transparent',
    },
  };

  const vikontSideBySide = {
    image: {
      aspectRatio: 2 / 3,
      maxWidth: 430,
      interimageSpacing: 15,
      leftImage: {
        borderRadius: '0',
      },
      rightImage: {
        borderRadius: '0',
      },
    },
    caption: {
      useVerticalCaptions: false,
      sideColor: colors.primary,
      margin: '10px 0 0 0',
    },
  };

  const vikontReadMore = {
    block: {
      background: 'transparent',
      padding: '15px 30px',
      margin: 0,
      borderRadius: 0,
      borderTop: 'none',
      borderBottom: 'none',
      borderLeft: 'none',
      borderRight: 'none',
    },
    title: {
      color: colors.primary,
      font: texts.body.font,
      textTransform: 'none',
      letterSpacing: 'normal',
      marginBottom: '18px',
      textAlign: 'left',
    },
    drum: {
      arrowsShift: -10,
      arrowsShiftVertical: 0,
      itemWidth: '33.3%',
      spaceBetween: 30,
      sideIndent: 30,
      noCounter: false,
      autoHeight: false,
    },
    feed: {
      interitemSpacing: 30,
      columns: 1,
    },
    singleCard: {
      alignItems: 'normal',
    },
    amp: {
      card: Card2,
      presenter: Feed,
    },
  };

  const vikontSlide = {
    borderRadius: 0,
    singleCaption: false,
  };

  const vikontIncut = {
    borderWidth: '4px',
    borderColor: colors.divider,
    padding: '26px 56px',
    font: texts.incut.font,
    color: texts.incut.color,
    textAlign: 'center',
  };

  const mark = {
    padding: '0 0.1em',
    color: colors.primary,
    background: color(colors.active1).lightness(85).hex(),
  };

  const topicContent = {
    widgetsMaxWidth: 760,
    widgetsWithMaxWidth: {
      'markdown': true,
      'interview': true,
      'incut': true,
      'readMore': true,
      'opinion': true,
      'number': true,
      'spoiler': true,
      'recipe': true,
      'publicationLink': true,
      'tableMarkdown': true,
    },
    widgetsWithNegativeMobileIndent: {
      'image': true,
      'sideBySide': true,
      'photoGallery': true,
      'summary': true,
      'galleryLink': true,
      'readMore': true,
      'slides': true,
    },
    heading: {
      clear: 'both',
    },
    tableOfContents: {
      borderBottom: `1px solid ${colors.divider}`,
      margin: '0 0 30px 0',
      padding: '0 0 15px 0',
      maxWidth: 'none',
      listPadding: '0 0 0 20px',
      listStyle: 'disc',
      title: {
        font: texts.title2.font,
        color: texts.title2.color,
        display: 'block',
      },
      link: {
        color: colors.primary,
        borderBottom: '1px dotted',
        hover: {
          borderBottom: '1px dotted transparent',
          color: colors.active1,
        },
      },
    },
    widget: {
      top: 24,
      bottom: 24,
    },
    image: {
      bottom: 36,
    },
    list: {
      top: 36,
      bottom: 36,
    },
    ads: {
      top: 24,
      bottom: 24,
    },
    /**
     * Отключаем erid для феры. Из-за плагина,
     * который рендерится после TopicContent
     * и для мотора, из-за отсутствия max-width у виджетов
     */
    showErid: true,
  };

  const interview = {
    /**
     * interitemSpacing определяет отступ между вопросом и ответами.
     * По-умолчанию берется из props компонента TopicContent.
     */
    interitemSpacing: null,
    question: {
      name: {
        color: texts.body.color,
      },
      body: {
        fontStyle: 'normal',
      },
    },
  };

  const stickyPlate = {
    background: colors.content,
    close: {
      fill: colors.primary,
      background: colors.content,
    },
  };

  const sponsored = {
    font: `14px/18px ${fonts.text}`,
    color: colors.primary,
  };

  const commentsPreview = {
    headline: {
      font: `bold 34px/42px ${fonts.display}`,
      color: colors.primary,
      textTransform: 'none',
    },
    name: {
      font: `bold 16px/20px ${fonts.display}`,
    },
    date: {
      font: `normal 12px/16px ${fonts.display}`,
    },
    comment: {
      font: `normal 16px/20px ${fonts.display}`,
    },
    button: {
      margin: 0,
    },
  };

  const dropdown = {
    content: {
      background: colors.content,
      boxShadowColor: color(colors.primary).alpha(0.4).string(),
      border: `1px solid ${color(colors.placeholder).alpha(0.1).string()}`,
    },
  };

  const checkbox = {
    basic: {
      idle: {
        fill: colors.active1,
      },
      focus: {
        fill: colors.active1,
      },
      checked: {
        fill: colors.active1,
      },
      disabled: {
        fill: colors.primary,
      },
      checkedDisabled: {
        fill: colors.primary,
      },
    },
    secondary: {
      idle: {
        fill: colors.active2,
      },
      focus: {
        fill: colors.active2,
      },
      checked: {
        fill: colors.active2,
      },
      disabled: {
        fill: colors.primary,
      },
      checkedDisabled: {
        fill: colors.primary,
      },
    },
  };

  const radio = {
    basic: {
      idle: {
        fill: colors.active1,
      },
      focus: {
        fill: colors.active1,
      },
      checked: {
        fill: colors.active1,
      },
      disabled: {
        fill: colors.primary,
      },
      checkedDisabled: {
        fill: colors.primary,
      },
    },
    secondary: {
      idle: {
        fill: colors.active2,
      },
      focus: {
        fill: colors.active2,
      },
      checked: {
        fill: colors.active2,
      },
      disabled: {
        fill: colors.primary,
      },
      checkedDisabled: {
        fill: colors.primary,
      },
    },
  };

  const avatar = {
    isCircular: false,
    svg: {
      border: {
        stroke: '#E9E9E9',
        fill: '#fff',
      },
      content: {
        stroke: '#B7B7B7',
        fill: '#fff',
      },
    },
    border: 'none',
    background: 'none',
    boxShadow: 'none',
  };

  const author = {
    types: {
      expert: {
        background: colors.active1,
        color: colors.content,
        borderRadius: 0,
        textTransform: 'none',
        border: 'none',
      },
    },
  };

  const personal = {
    headerButtonText: {
      textTransform: 'none',
      color: colors.primary,
      textDecoration: 'none',
      fontWeight: 'normal',
    },

    circleCheckMark: {
      fill: colors.active1,
      stroke: colors.content,
    },

    profileAvatar: {
      isCircular: false,
    },
  };

  const topicHeaderTexts = {
    title: texts.title1,
    subtitle: texts.title2,
    lead: {
      ...texts.lead,
      top: 15,
    },
    firstLetter: {
      font: `bold 90px/100px ${fonts.display}`,
    },
    divider: null,
    expert: {
      margin: '25px 0 0 0',
    },
    marginBottom: 20,

    premiumTopic: {
      textColor: '#bababa',
      subtitle: {
        font: `26px/32px ${fonts.text}`,
      },
      title: {
        font: `800 42px/52px ${fonts.text}`,
      },
      background: colors.content,
    },
  };

  const mailing = {
    background: colors.layout,
    color: colors.primary,
    formElements: {
      radius: 0,
      height: '45px',
    },
    header: {
      width: '100%',
      font: `bold 30px/38px ${fonts.display}`,
      padding: 0,
      textTransform: 'none',
      mobile: {
        font: `bold 18px/25px ${fonts.display}`,
        padding: 0,
        textTransform: 'none',
        width: 'auto',
      },
    },
    text: {
      font: `12px/1 ${fonts.text}`,
      mobile: {
        font: `9px/1 ${fonts.text}`,
      },
    },
  };

  const socializatorIconState = {
    boxShadow: '0 4px 11px 0 rgba(0,0,0,.11)',
    background: '#292929',
    iconSize: 18,
  };

  const socializator = {
    fixedPosition: 'right',
    borderRadius: 18,
    buttonHeight: 36,
    iconSize: 20,
    counterSize: 12,
    borderWidth: 0,
    textColor: '#FFF',
    iconsGap: 15,
    color: '#FFF',
    opened: {
      ...socializatorIconState,
      icon: icons.close,
    },
    closed: {
      ...socializatorIconState,
      icon: icons.arrowShare,
    },
  };

  const captionCredits = {
    textAlign: 'center',
    background: 'none',
    padding: 0,
    maxWidth: layout.contentColumnMaxWidth,
    margin: '0 auto',
    caption: {
      font: `14px/18px ${fonts.text}`,
      color: colors.primary,
      margin: 0,
    },
    credits: {
      font: `14px/18px ${fonts.text}`,
      color: colors.hint,
      margin: 0,
    },
  };

  const topicTopline = {
    font: `14px/1 ${fonts.display}`,
    color: 'rgba(0, 0, 0, .6)',
    textTransform: 'none',
    letterSpacing: 0,
    rubric: {
      font: `14px/1 ${fonts.display}`,
      color: colors.active2,
      border: `1px solid ${colors.active2}`,
      borderRadius: '20px',
      padding: '5px 15px',
      background: 'transparent',
      textTransform: 'none',
      letterSpacing: 0,
      decoration: 'none',
      hover: {
        color: color(colors.active2)
          .mix(color(colors.primary), 0.2)
          .string(),
        background: color(colors.active2).alpha(0.3).string(),
        decoration: 'none',
      },
      premiumTopic: {
        color: colors.active2,
      },
    },
  };

  const authorPage = {
    card: {
      archivedAuthor: {
        font: texts.bodySmall.font,
      },
      name: {
        font: texts.title3.font,
      },
    },
  };

  const authorsPage = {
    card: {
      name: {
        font: `600 18px/24px ${fonts.display}`,
      },
      linkType: 'tertiary',
    },
  };

  const expert = {
    wrapper: {
      flexDirection: 'row',
      alignItems: 'start',
    },
    info: {
      alignItems: 'start',
      marginLeft: '24px',
    },
    name: {
      idle: {
        color: colors.primary,
        font: `700 16px/24px ${fonts.display}`,
        borderBottom: 'none',
        textTransform: 'none',
        margin: '0 0 5px 0',
      },
      hover: {
        color: colors.active1,
        font: `700 16px/24px ${fonts.display}`,
        borderBottom: 'none',
        textTransform: 'none',
        margin: '0 0 5px 0',
      },
    },
    jobTitle: {
      color: color(colors.primary).alpha(0.5).string(),
      font: `400 14px/20px ${fonts.display}`,
    },
    label: {
      background: color(colors.primary).alpha(0.8).string(),
      color: colors.content,
      font: `700 10px/1 ${fonts.display}`,
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
      borderRadius: '0',
    },
    avatar: {
      borderRadius: '0',
      isAvatarCircular: false,
      width: 64,
    },
  };


  const notes = {
    background: colors.grey,
    borderColor: colors.divider,
    linkType: 'secondary',
    headlineFontFamily: fonts.display,
    font: texts.body.font,
  };

  const story = {
    placeholder: {
      backgroundColor: colors.placeholder,
      height: 190,
    },
    slide: {
      width: 145,
      spaceBetween: 15,
    },
  };

  const storyCard = {
    card: {
      border: 'none',
      borderRadius: 0,
      Card: null,
    },
    headline: {
      font: `bold 14px/18px ${fonts.display}`,
      textTransform: 'none',
      color: colors.content,
    },
    statusLine: {
      border: `2px solid ${colors.active1}`,
      borderRadius: 0,
      indent: '2px',
      Custom: null,
    },
    premium: {
      TopIcon: PremiumStory,
      BottomIcon: null,
    },
  };

  const storyWidgets = {
    color: colors.content,
    navigation: {
      background: colors.active2,
    },
  };

  const storyWidgetsBaseCard = {
    color: colors.content,
    buttonType: 'primary',
    headline: {
      font: `500 24px/30px ${fonts.display}`,
      textTransform: 'uppercase',
    },
    lead: {
      font: `500 italic 16px/20px ${fonts.display}`,
    },
    button: {
      minWidth: 0,
    },
  };

  const storyWidgetsVariants = {
    headline: {
      font: `500 24px/30px ${fonts.display}`,
      textTransform: 'none',
    },

    twoVariants: {
      caption: {
        font: `500 24px/30px ${fonts.display}`,
      },
    },
    threeVariants: {
      caption: {
        font: `500 18px/22px ${fonts.display}`,
      },
    },

    states: {
      idle: {
        caption: {
          color: colors.primary,
          background: colors.active1,
        },
        image: {
          boxShadow: `-3px 3px 0 0 ${colors.active1}`,
        },
      },
      hover: {
        caption: {
          color: colors.primary,
          background: colors.active1,
        },
        image: {
          boxShadow: `-5px 5px 0 0 ${colors.active1}`,
        },
      },
      checked: {
        caption: {
          color: colors.primary,
          background: colors.active1,
        },
        image: {
          boxShadow: `-3px 3px 0 0 ${colors.active1}`,
        },
      },

      disabled: {
        caption: {
          color: colors.primary,
          background: colors.content,
        },
        image: {
          boxShadow: `-3px 3px 0 0 ${colors.content}`,
        },
      },

      disabledQuiz: {
        caption: {
          color: colors.primary,
          background: color(colors.active1).mix(color(colors.primary), 0.3).string(),
        },
        image: {
          boxShadow: `-3px 3px 0 0 ${color(colors.active1).mix(color(colors.primary), 0.3).string()}`,
        },
      },

      wrong: {
        caption: {
          color: colors.primary,
          background: colors.error,
        },
        image: {
          boxShadow: `-3px 3px 0 0 ${colors.error}`,
        },
      },
    },
  };

  const storyWidgetsRatingCard = {
    color: colors.content,
    headline: {
      font: `500 28px/35px ${fonts.display}`,
      textTransform: 'none',
    },
    count: {
      font: `96px/1.2 ${fonts.display}`,
    },
    percent: {
      font: `36px/45px ${fonts.display}`,
      bottomIndent: '16px',
    },
  };

  const storyWidgetsHiddenPhoto = {
    question: {
      color: colors.content,
      font: `700 24px/30px ${fonts.display}`,
      textTransform: 'none',
    },

    answerText: {
      font: `700 14px/14px ${fonts.display}`,
    },

    states: {
      correct: {
        answerText: {
          color: colors.primary,
          background: colors.active1,
        },
      },
      incorrect: {
        answerText: {
          color: colors.content,
          background: colors.error,
        },
      },
    },

    variant: {
      borderRadius: '30px',
      font: `700 16px/20px ${fonts.display}`,
      padding: '7px 33px 9px',
      textTransform: 'none',
      idle: {
        color: colors.content,
        border: `1px solid ${color(colors.content).alpha(0.7).toString()}`,
        background: 'transparent',
      },
      hover: {
        color: colors.primary,
        border: `1px solid ${colors.active1}`,
        background: colors.active1,
      },
      checkedCorrect: {
        color: colors.primary,
        border: `1px solid ${colors.active1}`,
        background: colors.active1,
      },
      checkedIncorrect: {
        color: colors.content,
        border: `1px solid ${colors.error}`,
        background: colors.error,
      },
    },
  };

  const reactions = {
    const: {
      orientation: 'column',
    },

    tiny: {
      font: `500 11px/13px ${fonts.display}`,
      radius: 0,
      padding: '0 4px',
      gap: '6px',
      emojiSize: 24,
    },

    small: {
      font: `500 14px/16px ${fonts.display}`,
      radius: '14px',
      padding: '4px 7px',
      gap: '6px',
      emojiSize: 24,
    },

    primary: {
      idle: {
        color: colors.active1,
        border: 'none',
        background: 'transparent',
      },
      checked: {
        color: colors.input,
        border: 'none',
        background: colors.active1,
      },
      focus: {
        color: colors.active1,
        border: 'none',
        background: 'transparent',
      },
      disabled: {
        color: colors.active1,
        border: 'none',
        background: 'transparent',
      },
      checkedDisabled: {
        color: colors.input,
        border: 'none',
        background: colors.active1,
      },
    },

    topic: {
      idle: {
        color: colors.primary,
        border: 'none',
        background: 'transparent',
      },
      checked: {
        color: colors.primary,
        border: 'none',
        background: 'transparent',
      },
      focus: {
        color: colors.primary,
        border: 'none',
        background: 'transparent',
      },
      disabled: {
        color: color(colors.primary).alpha(0.5).toString(),
        border: 'none',
        background: 'transparent',
      },
      checkedDisabled: {
        color: colors.primary,
        border: 'none',
        background: 'transparent',
      },
    },
  };

  const reactionsEmojiBar = {
    const: {
      padding: '30px 42px',
      borderRadius: '5px',
      background: colors.content,
      border: 'none',
      boxShadow: 'none',
    },

    title: {
      color: colors.primary,
      font: `bold 16px/20px ${fonts.display}`,
    },

    controls: {
      alignment: 'center',
      interitemSpacing: 14,
    },
  };

  const skeleton = {
    background: colors.placeholder,
  };

  const gameCompare = {
    indent: Indent,
    showComments: false,
    question: {
      font: `700 18px/27px ${fonts.text}`,
      color: colors.primary,
    },
    tooltip: {
      buttonSize: 'small',
      buttonType: 'primary',
      info: {
        fill: colors.content,
        background: colors.active1,
        font: `700 12px/12px ${fonts.text}`,
        hover: {
          background: colors.active1,
        },
      },
      scheme: {
        titleFont: `400 20px/33px ${fonts.text}`,
        textFont: `300 18px/26px ${fonts.text}`,
        border: colors.primary,
        color: colors.primary,
        innerColor: colors.active1,
        outerColor: colors.primary,
      },
      theme: 'light',
    },
    progressbar: {
      separationText: ' из ',
      progressInside: false,
      strokeColor: colors.divider,
      iconFill: colors.primary,
      textColor: colors.primary,
      progressColor: colors.primary,
      background: colors.content,
      font: `700 12px/17px ${fonts.text}`,
      vs: Vs,
    },
    announce: {
      font: `20px/29px ${fonts.text}`,
      color: colors.primary,
      announceIndent: Indent,
    },
    compare: {
      borderRadius: 0,
      progressType: 0,
      margin: 0,
      caption: {
        color: colors.primary,
        background: colors.content,
        font: `700 12px/15px ${fonts.display}`,
      },
      credits: {
        color: colors.primary,
        font: `400 13px/15px ${fonts.text}`,
      },
      draw: {
        backgroundColor: colors.layout,
        backgroundText: `linear-gradient(45deg, ${colors.active1} , ${color(colors.active1).alpha(0.1).toString()})`,
        font: `700 36px/47px ${fonts.display}`,
        credits: {
          font: `12px/18px ${fonts.text}`,
          color: colors.placeholder,
        },
      },
      text: {
        color: colors.primary,
        font: `400 18px/27px ${fonts.text}`,
        background: colors.active2,
      },
    },
    leaderBoard: {
      card: null,
      table: {
        borderColor: color(colors.primary).alpha(0.1).toString(),
        background: color(colors.primary).alpha(0.02).toString(),
        activeBackground: color(colors.primary).alpha(0.1).toString(),
        indent: EmptyWrapper,
      },
      header: {
        color: colors.primary,
        font: `700 12px/17px ${fonts.display}`,
        questionBackground: colors.placeholder,
        questionFill: colors.primary,
        textTransform: 'none',
      },
      count: {
        background: colors.placeholder,
        font: `700 18px/20px ${fonts.display}`,
        color: colors.primary,
        activeBackground: colors.primary,
        activeColor: colors.content,
      },
      progressbar: {
        height: '5px',
        progressHeight: '5px',
        background: colors.placeholder,
        defaultProgress: colors.active1,
        finalProgress: colors.primary,
        activeBackground: colors.placeholder,
        font: `12px/17px ${fonts.text}`,
      },
      modalWindow: {
        text: `300 16px/23px ${fonts.text}`,
        title: `400 18px/30px ${fonts.text}`,
        color: colors.primary,
        iconFill: colors.placeholder,
      },
      dropdown: {
        theme: 'light',
      },
      button: {
        buttonType: 'primary',
        siteButton: null,
      },
      caption: `300 18px/26px ${fonts.text}`,
      ratings: `700 16px/20px ${fonts.display}`,
      draw: {
        background: colors.active1,
      },
      pairCompare: {
        margin: '40px 0 20px',
      },
    },
    winner: {
      icon: Winner,
      background: colors.content,
      strokeFill: 'transparent',
      strokeColor: colors.primary,
      fillColor: colors.primary,
      viewBox: '0 0 380 240',
      padding: 0,
      iconStep: 50,
      borderRadius: 0,
      imageTop: 0,
    },
    share: {
      font: `700 12px/17px ${fonts.display}`,
      color: colors.primary,
      text: 'Поделитесь с друзьями:',
      showBorder: false,
      textTransform: 'none',
      marginTop: 0,
    },
    concidences: {
      font: `300 20px/29px  ${fonts.text}`,
      color: colors.primary,
      margin: '0 0 25px',
      highlight: true,
    },
    compareCard: {
      progressbar: {
        progress: 100,
        progressInside: false,
        progressType: 1,
        progressColor: colors.primary,
        strokeColor: colors.primary,
        iconFill: colors.layout,
        background: colors.primary,
      },
    },
  };

  const profile = {
    background: 'rgba(241, 241, 246, 0.5)',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: '4px',
    name: {
      font: `600 16px/20px ${fonts.display}`,
      color: colors.primary,
    },
    email: {
      font: `400 12px/14px ${fonts.text}`,
      color: colors.primary,
    },
    logout: {
      font: `600 14px/17px ${fonts.text}`,
      color: colors.primary,
    },
    description: {
      font: `500 14px/17px ${fonts.text}`,
      color: colors.primary,
    },
  };

  const login = {
    popup: {
      theme: 'light',
      background: colors.content,
      button: {
        font: `600 16px/19px ${fonts.display}`,
        color: '#fff',
      },
      content: {
        font: `400 12px/18px ${fonts.display}`,
        color: 'rgba(0, 0, 0, .4)',
      },
    },
    modal: {
      button: {
        font: `600 16px/21px ${fonts.display}`,
        color: colors.primary,
      },
      content: {
        font: `400 16px/23px ${fonts.display}`,
        color: colors.primary,
      },
    },
  };

  const fullscreen = {
    closeIcon: icons.close,
    background: colors.fullscreenBg,
  };

  const advTooltip = {
    font: `400 12px/15px ${fonts.text}`,
  };

  const tags = {
    margin: 0,
    padding: 0,
  };

  const about = {
    headline: {
      font: `bold 42px/52px ${fonts.text}`,
      color: colors.primary,
    },
    title2: {
      font: `bold 34px/42px ${fonts.text}`,
      color: colors.primary,
    },
    padding: '0 55px',
  };

  const cookiesBanner = {
    background: colors.primary,
    bannerOffsetBottom: '10px',

    text: {
      font: `400 12px/16px ${fonts.text}`,
      color: colors.content,
    },

    button: {
      btnSize: 'small',
      btnType: 'primary',
      btnRadius: '4px',
      btnText: `500 14px/16px ${fonts.text}`,
    },
  };

  const controls = deepmerge({
    drum,
    fullscreen,
    link,
    input,
    searchInput,
    shapka,
    dropdown,
    button,
    bullet,
    bullets,
    gallery,
    topicPages,
    paginatron,
    counter,
    scooter,
    topicFooter,
    topicTags,
    spammer,
    comments,
    bouesque,
    vikontImage,
    vikontOpinion,
    vikontSpoiler,
    vikontVerdict,
    vikontSideBySide,
    vikontReadMore,
    vikontSlide,
    vikontIncut,
    topicContent,
    stickyPlate,
    commentsPreview,
    checkbox,
    radio,
    avatar,
    author,
    expert,
    personal,
    logo,
    topicHeaderTexts,
    mailing,
    socializator,
    captionCredits,
    topicTopline,
    authorPage,
    authorsPage,
    notes,
    mark,
    story,
    storyCard,
    storyWidgets,
    storyWidgetsBaseCard,
    storyWidgetsVariants,
    storyWidgetsRatingCard,
    storyWidgetsHiddenPhoto,
    reactions,
    reactionsEmojiBar,
    interview,
    skeleton,
    smartTeaser,
    gameCompare,
    profile,
    login,
    advTooltip,
    tags,
    about,
    cookiesBanner,
    commentButton,
  }, params.controls || {});

  const ads = deepmerge({
    sponsored,
    urlPreviewImage: {
      retina: null,
      common: null,
    },
  }, params.ads || {});

  const errorPageParams = {
    background: colors.content,
    imgUrl: '',
    buttonSize: 'extraLarge',
    buttonType: 'tertiary',
    buttonText: 'ПЕРЕЙТИ НА ГЛАВНУЮ',
    imgWidth: 0,
    padding: '80px 20px 20px',
    title: {
      font: `bold 32px/38px ${fonts.display}`,
      color: colors.primary,
    },
    subtitle: {
      name: 'Что-то пошло не так',
      font: `14px/16px ${fonts.text}`,
      color: colors.primary,
    },
    card: null,
    popular: {
      background: 'transparent',
      padding: '20px',
      drumPadding: 0,
      interitemSpacing: 10,
      header: {
        padding: '20px 0 0 0',
      },
      title: {
        font: `bold 32px/36px ${fonts.display}`,
        color: colors.primary,
      },
    },
  };

  const pages = deepmerge({
    error: {
      ...errorPageParams,
      subtitle: {
        ...errorPageParams.subtitle,
        name: 'Что-то пошло не так',
      },
    },
    notFound: {
      ...errorPageParams,
      title: {
        ...errorPageParams.title,
        name: '404',
      },
      subtitle: {
        ...errorPageParams.subtitle,
        name: 'Страница не найдена',
      },
    },
    sentryFallback: {
      ...errorPageParams,
      title: {
        ...errorPageParams.title,
        name: 'Что-то пошло не так',
      },
      subtitle: {
        ...errorPageParams.subtitle,
        name: 'Мы уже знаем об этом и скоро всё исправим',
      },
    },
    development: {
      ...errorPageParams,
      title: {
        ...errorPageParams.title,
        name: 'Раздел в разработке',
      },
      subtitle: {
        ...errorPageParams.subtitle,
        name: 'Пожалуйста, зайдите сюда позже',
      },
    },
    offline: {
      ...errorPageParams,
      title: {
        ...errorPageParams.title,
        name: 'Нет подключения к Интернету',
      },
      subtitle: {
        ...errorPageParams.title,
        name: 'Проверьте подключение к Интернету.',
      },
    },
  }, params.pages || {});

  return {
    fonts,
    icons,
    colors,
    texts,
    socials,
    animations,
    controls,
    ads,
    layout,
    pages,
  };
}
